module.exports = __webpack_public_path__ + "img/carousel_3.d4bcaaad.jpg";